import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b5fb0344: FaireBrandEntity = {
  token: "b_b5fb0344",
  type: "brand",
  name: "Brooklyn Candle Studio",
  avatarUrl:
    "https://cdn.faire.com/fastly/1b215321454ff15503629b2b976da4327a2fbd48e6c1018975bbb7680bd61734.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/17774fc18b53ce1976b082980727e7eac3a522e87e4384c3448a447043cc34b5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1b215321454ff15503629b2b976da4327a2fbd48e6c1018975bbb7680bd61734.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/17774fc18b53ce1976b082980727e7eac3a522e87e4384c3448a447043cc34b5.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 147,
  isInsider: true,
  description:
    "Brooklyn Candle Studio is an independent candle design and manufacturing studio based out of Brooklyn, New York. Our small team handcrafts our candles with a blend of soy wax, essential oils, and phthalate-free perfume oils. Our dreamy scents are inspired by nature and travel, and our aesthetic is minimalist yet impossibly chic.\n\nWe use soy wax derived from American-grown soy beans for an eco-friendly, clean burn and lead-free cotton core wicks primed with vegetable based wax. Our candles are preservative and petroleum-free, cruelty-free and 100% vegan. We are an eco-conscious company, opting to use recyclable packaging and shipping materials and as little plastic as possible.\n\nOur candles are ethically produced by our small team in our studio space in Industry City, a hub of of makers, designers, artists, and small businesses. All of our employees earn at least $18 an hour with benefits: paid time off and subsidized healthcare, dental, and vision. We also pride ourselves on safe, comfortable working conditions.\n\nWe like to think of our wares as full sensory experiences—from the artful minimal packaging to the warm candlelight and delicate aromas that fill a room.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:21.711Z",
    importedBy: "entity-db-cli",
  },
};
